import React from 'react';
import './Input.css';

export const Input = ({ label, id, error, className = '', ...rest }) => (
  <div className={`ui-form-group ${className}`.trim()}>
    {label && <label htmlFor={id}>{label}</label>}
    <input id={id} className={error ? 'ui-input-error' : ''} {...rest} />
    {error && <span className="ui-input-error-text">{error}</span>}
  </div>
);

export default Input;
